import { useEffect, useState } from "react";
import { useUser } from "../../../contexts/UserContext";
import { UserBank } from "../../types/banks/UserBank";
import { FirestoreUserBankRepository } from "../../../infrastructure/repositories/UserBankRepository";

export function useUserBanks() {
  const { appUser, loading: userLoading } = useUser();
  const [userBanks, setUserBanks] = useState<UserBank[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (userLoading) {
      return;
    }

    if (!appUser) {
      setLoading(false);
      return;
    }

    const repository = new FirestoreUserBankRepository();

    const unsubscribe = repository.observeUserBanksByAppUserId(
      appUser.appUserId,
      (banks) => {
        setUserBanks(banks);
        setLoading(false);
      },
      (err) => {
        console.error("Error fetching user banks:", err);
        setError(err);
        setLoading(false);
      },
    );

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [appUser, userLoading]);

  return { userBanks, loading, error };
}
